import {Component, input, OnInit} from '@angular/core';
import {TemplateService} from "../../common/service/template.service";
import {LanguageService} from "../../service/language.service";
import {TemplateCodeTypes} from "../../enum/template-code.enum";
import {TemplateDTO} from "../../common/model/template-dto.model";

@Component({
  selector: 'app-template-content',
  templateUrl: './template-content.component.html',
  styleUrls: ['./template-content.component.scss'],
})
export class TemplateContentComponent  implements OnInit {

  code = input<TemplateCodeTypes>();
  template = input<TemplateDTO>();

  isLoading: boolean;
  content: string;

  constructor(private templateService: TemplateService) { }

  ngOnInit() {

    this.isLoading = true;

    if(!this.template()){
      this.templateService.getTemplateByCode(this.code()).subscribe(template => {
        this.content = LanguageService.getTranslation(template.body, 'description');
        this.isLoading = false;
      });
    }

  }

}
